import React, { useEffect, useMemo, useState } from 'react';
import { X } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { transportApi } from '@/services/transportApi';

/** Transport Settings: who gets pending / unassigned request alerts on Messenger. */
export const AlertRecipients = ({ value, onChange }) => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => { transportApi.listUsers().then((u) => setUsers(Array.isArray(u) ? u : [])).catch(() => {}); }, []);
  const byId = useMemo(() => Object.fromEntries(users.map((u) => [u.user_id, u])), [users]);
  const matches = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return [];
    return users.filter((u) => !value.includes(u.user_id) && `${u.name} ${u.role} ${u.email || ''}`.toLowerCase().includes(s)).slice(0, 8);
  }, [q, users, value]);

  return (
    <Card className="border-0 shadow-md"><CardContent className="p-5">
      <h3 className="font-semibold">Transport Alert Recipients</h3>
      <p className="text-sm text-gray-500 mb-3">Who gets Messenger alerts for pending / unassigned vehicle requests, auto-assign notes and rejected stops. Leave empty to alert every <b>Transport Manager</b>.</p>
      <div className="flex flex-wrap gap-2 mb-3" data-testid="settings-alert-list">
        {value.length === 0 && <span className="text-xs text-gray-400" data-testid="settings-alert-default">Default — all Transport Managers</span>}
        {value.map((id) => (
          <Badge key={id} variant="secondary" className="pl-3 pr-1 py-1 text-sm" data-testid={`settings-alert-user-${id}`}>
            {byId[id]?.name || id}<span className="ml-1 text-[10px] text-gray-500">{byId[id]?.role || ''}</span>
            <button onClick={() => onChange(value.filter((x) => x !== id))} className="ml-1 text-gray-400 hover:text-red-500" data-testid={`settings-alert-remove-${id}`}><X className="w-3 h-3" /></button>
          </Badge>
        ))}
      </div>
      <div className="relative max-w-sm">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a user by name or role to add" data-testid="settings-alert-search" />
        {matches.length > 0 && (
          <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg max-h-64 overflow-y-auto" data-testid="settings-alert-results">
            {matches.map((u) => (
              <button key={u.user_id} type="button" onClick={() => { onChange([...value, u.user_id]); setQ(''); }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 flex justify-between gap-2" data-testid={`settings-alert-add-${u.user_id}`}>
                <span>{u.name}</span><span className="text-xs text-gray-500">{u.role}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </CardContent></Card>
  );
};

export default AlertRecipients;
